import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import './imports.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

var entries = require('object.entries');
if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        return resArray;
    };
}
if (!Object.entries) {
    entries.shim();
}

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js